import * as React from "react";
import {Order} from "../models/order";
import {moneyFormat} from "../utils";
import {Col, Row} from "react-bootstrap";

export interface TotalProps {
    order: Order;
}

export const PackageTotals: React.SFC<TotalProps> = (props) => {
    const {grandTotal, subTotal, discountTotal, taxTotal, shippingTotal, insuranceTotal, memoryMakerTotal, geniePlusTotal} = props.order;
    return <div>
        <Row>
            <Col md={2} className="total-label">Subtotal</Col>
            <Col md={2} className="subtotal">{moneyFormat(subTotal)}</Col>
        </Row>

        {discountTotal > 0 && <Row>
            <Col md={2} className="total-label">Discount</Col>
            <Col md={2} className="subtotal">{moneyFormat(discountTotal)}</Col>
        </Row>}

        {taxTotal > 0 && <Row>
            <Col md={2} className="total-label">Tax</Col>
            <Col md={2} className="subtotal">{moneyFormat(taxTotal)}</Col>
        </Row>}

        {shippingTotal > 0 && <Row>
          <Col md={2} className="total-label">Delivery</Col>
          <Col md={2} className="subtotal">{moneyFormat(shippingTotal)}</Col>
        </Row>}

        {insuranceTotal > 0 && <Row>
          <Col md={2} className="total-label">Insurance</Col>
          <Col md={2} className="subtotal">{moneyFormat(insuranceTotal)}</Col>
        </Row>}

        {memoryMakerTotal > 0 && <Row>
          <Col md={2} className="total-label">Memory Maker</Col>
          <Col md={2} className="subtotal">{moneyFormat(memoryMakerTotal)}</Col>
        </Row>}

        {geniePlusTotal > 0 && <Row>
            <Col md={2} className="total-label">Genie+</Col>
            <Col md={2} className="subtotal">{moneyFormat(geniePlusTotal)}</Col>
        </Row>}

        <Row>
            <Col md={2} className="total-label bold">Grand Total</Col>
            <Col md={2} className="grandtotal">{moneyFormat(grandTotal)}</Col>
        </Row>
    </div>;
};



// WEBPACK FOOTER //
// ./src/components/PackageTotals.tsx